import React, { Fragment } from 'react';
import { motion } from 'framer-motion';
import { Navigation } from '../components/Navigation';
import { useLanguage } from '../lib/LanguageContext';
import { translations } from '../lib/translations';
export const ProductsPage = () => {
  const {
    lang
  } = useLanguage();
  const t = translations[lang].products;
  return <div style={{
    backgroundColor: 'var(--white)',
    color: 'var(--black)',
    minHeight: '100vh'
  }} data-id="element-502">
      <Navigation data-id="element-503" />

      <div style={{
      maxWidth: '56rem',
      margin: '0 auto',
      padding: '10rem 2rem 8rem'
    }} data-id="element-504">
        {/* ── SECTION 1: WB-PLATFORM ── */}
        <section style={{
        marginBottom: '8rem'
      }} data-id="element-505">
          <motion.p initial={{
          opacity: 0
        }} animate={{
          opacity: 1
        }} transition={{
          duration: 0.6
        }} style={{
          fontFamily: '"IBM Plex Mono", monospace',
          fontSize: '0.65rem',
          letterSpacing: '0.3em',
          textTransform: 'uppercase',
          color: 'var(--grey-500)',
          marginBottom: '3rem'
        }} data-id="element-506">
            {t.platformLabel}
          </motion.p>

          <motion.div initial={{
          opacity: 0,
          y: 20
        }} animate={{
          opacity: 1,
          y: 0
        }} transition={{
          duration: 0.8,
          ease: [0.16, 1, 0.3, 1]
        }} style={{
          display: 'flex',
          alignItems: 'flex-start',
          gap: '1.5rem',
          flexWrap: 'wrap',
          marginBottom: '0.75rem'
        }} data-id="element-507">
            <h2 style={{
            fontFamily: '"IBM Plex Sans", sans-serif',
            fontWeight: 300,
            fontSize: 'clamp(2.5rem, 6vw, 4rem)',
            letterSpacing: '-0.02em',
            lineHeight: 1,
            color: 'var(--black)',
            margin: 0
          }} data-id="element-508">
              {t.platformName}
            </h2>
          </motion.div>

          <p style={{
          fontFamily: '"IBM Plex Sans", sans-serif',
          fontWeight: 300,
          fontSize: '1.125rem',
          color: 'var(--grey-500)',
          marginBottom: '4rem'
        }} data-id="element-509">
            {t.platformSub}
          </p>

          {/* Stats row */}
          <div style={{
          display: 'grid',
          gridTemplateColumns: 'repeat(auto-fit, minmax(200px, 1fr))',
          borderTop: '1px solid rgba(0,0,0,0.08)',
          marginBottom: '4rem'
        }} data-id="element-510">
            {t.stats.map((stat, i) => <motion.div key={i} initial={{
            opacity: 0,
            y: 16
          }} animate={{
            opacity: 1,
            y: 0
          }} transition={{
            duration: 0.6,
            delay: 0.1 + i * 0.1
          }} style={{
            padding: '2rem 2rem 2rem 0',
            borderRight: i < 2 ? '1px solid rgba(0,0,0,0.08)' : 'none',
            paddingLeft: i > 0 ? '2rem' : 0
          }} data-id="element-511">
                <p style={{
              fontFamily: '"IBM Plex Mono", monospace',
              fontSize: '0.6rem',
              letterSpacing: '0.25em',
              textTransform: 'uppercase',
              color: 'var(--grey-500)',
              marginBottom: '0.5rem'
            }} data-id="element-512">
                  {stat.label}
                </p>
                <p style={{
              fontFamily: '"IBM Plex Sans", sans-serif',
              fontWeight: 400,
              fontSize: '0.9375rem',
              color: 'var(--grey-700)',
              lineHeight: 1.6
            }} data-id="element-513">
                  {stat.value}
                </p>
              </motion.div>)}
          </div>

          {/* Description lines */}
          <div style={{
          marginBottom: '3rem'
        }} data-id="element-514">
            {t.descLines.map((line, i) => <p key={i} style={{
            fontFamily: '"IBM Plex Sans", sans-serif',
            fontWeight: 300,
            fontSize: '1rem',
            color: 'var(--grey-700)',
            lineHeight: 2,
            margin: 0
          }} data-id="element-515">
                {line}
              </p>)}
          </div>

          {/* Em-dash spec list */}
          <div style={{
          marginBottom: '3rem'
        }} data-id="element-516">
            {t.specs.map((spec, i) => <p key={i} style={{
            fontFamily: '"IBM Plex Mono", monospace',
            fontSize: '0.75rem',
            letterSpacing: '0.2em',
            textTransform: 'uppercase',
            color: 'var(--grey-700)',
            lineHeight: 2.2,
            margin: 0
          }} data-id="element-517">
                — {spec}
              </p>)}
          </div>

          <div style={{
          borderTop: '1px solid rgba(0,0,0,0.08)'
        }} data-id="element-518" />
        </section>

        {/* ── SECTION 2: WB-CHIP ── */}
        <section style={{
        marginBottom: '8rem'
      }} data-id="element-519">
          <motion.p initial={{
          opacity: 0
        }} whileInView={{
          opacity: 1
        }} viewport={{
          once: true
        }} transition={{
          duration: 0.6
        }} style={{
          fontFamily: '"IBM Plex Mono", monospace',
          fontSize: '0.65rem',
          letterSpacing: '0.3em',
          textTransform: 'uppercase',
          color: 'var(--grey-500)',
          marginBottom: '3rem'
        }} data-id="element-520">
            {t.chipLabel}
          </motion.p>

          <motion.div initial={{
          opacity: 0,
          y: 20
        }} whileInView={{
          opacity: 1,
          y: 0
        }} viewport={{
          once: true
        }} transition={{
          duration: 0.8,
          ease: [0.16, 1, 0.3, 1]
        }} style={{
          display: 'flex',
          alignItems: 'flex-start',
          gap: '1.5rem',
          flexWrap: 'wrap',
          marginBottom: '0.75rem'
        }} data-id="element-521">
            <h2 style={{
            fontFamily: '"IBM Plex Sans", sans-serif',
            fontWeight: 300,
            fontSize: 'clamp(2.5rem, 6vw, 4rem)',
            letterSpacing: '-0.02em',
            lineHeight: 1,
            color: 'var(--black)',
            margin: 0
          }} data-id="element-522">
              {t.chipName}
            </h2>
          </motion.div>

          <p style={{
          fontFamily: '"IBM Plex Sans", sans-serif',
          fontWeight: 300,
          fontSize: '1.125rem',
          color: 'var(--grey-500)',
          marginBottom: '4rem'
        }} data-id="element-523">
            {t.chipSub}
          </p>

          {/* Description lines */}
          <div style={{
          marginBottom: '3rem'
        }} data-id="element-524">
            {t.chipLines.map((line, i) => <p key={i} style={{
            fontFamily: '"IBM Plex Sans", sans-serif',
            fontWeight: 300,
            fontSize: '1rem',
            color: 'var(--grey-700)',
            lineHeight: 2,
            margin: 0
          }} data-id="element-525">
                {line}
              </p>)}
          </div>

          {/* Capability statement */}
          <div style={{
          borderLeft: '2px solid rgba(0,0,0,0.1)',
          paddingLeft: '1.5rem',
          marginBottom: '3rem'
        }} data-id="element-526">
            <p style={{
            fontFamily: '"IBM Plex Sans", sans-serif',
            fontWeight: 300,
            fontSize: '1rem',
            color: 'var(--grey-700)',
            fontStyle: 'italic',
            lineHeight: 2,
            margin: 0,
            whiteSpace: 'pre-line'
          }} data-id="element-527">
              {t.chipQuote}
            </p>
          </div>

          {/* Em-dash spec list */}
          <div style={{
          marginBottom: '3rem'
        }} data-id="element-528">
            {t.chipSpecs.map((spec, i) => <p key={i} style={{
            fontFamily: '"IBM Plex Mono", monospace',
            fontSize: '0.75rem',
            letterSpacing: '0.2em',
            textTransform: 'uppercase',
            color: 'var(--grey-700)',
            lineHeight: 2.2,
            margin: 0
          }} data-id="element-529">
                — {spec}
              </p>)}
          </div>
        </section>
      </div>
    </div>;
};